module.exports = __webpack_public_path__ + "img/mobile_app_banner_fr.cf30d947.png";